import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface ILaipInsert {
  id?: string;
  mobileNo: string;
  eventCode: string;
  journeyName: string;
  tenor: string;
  roi: string;
  requestedLoanAmount: string;
  monthlyEmi: string;
  appId?: string;
}

export interface ILaipInsertApiResponse {
  id: string;
}

export const laipInsert = async (data: ILaipInsert): Promise<IResponse<ILaipInsertApiResponse>> => {
  const response = await encryptedRequest<ILaipInsertApiResponse, ILaipInsert>({
    method: "POST",
    url: API_PATHS.laipInsert,
    data: {
      ...data,
    },
  });
  return response;
};
